import React, { useState } from 'react';

export default function ChatInput({ onSend, disabled, placeholder }) {
    const [text, setText] = useState('');

    const handleSend = () => {
        const trimmed = text.trim();
        if (!trimmed || disabled) return;
        onSend(trimmed);
        setText('');
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            handleSend();
        }
    };

    return (
        <div className="chat-input-container">
            <textarea
                className="chat-input"
                value={text}
                onChange={e => setText(e.target.value)}
                onKeyDown={handleKeyDown}
                placeholder={placeholder || "Paste a recipe or describe what you want to cook..."}
                disabled={disabled}
                rows={3}
            />
            <button
                className="chat-send-button"
                onClick={handleSend}
                disabled={disabled || !text.trim()}
            >
                Send
            </button>
        </div>
    );
}
